import React, { useEffect, useState } from "react";
import { Flex, FormControl, FormLabel, Text, useMediaQuery } from "@chakra-ui/react";
import { ContentControls } from "./ContentControls";
import '@mdxeditor/editor/style.css';
import './TextContentElement.css';
import { useFocus } from "./useFocus";
import { PimcoreLink } from "./PimcoreLink";
import { PimcoreLinkButton } from "../components/PimcoreLinkButton";
import { SelectControl } from "./SelectControl";
import { useContentManagement } from "./ContentManagementProvider";
const defaults = {
    variant: "solid",
    link: {
        path: "",
        parameters: "",
        anchor: "",
        accesskey: "",
        rel: "",
        tabindex: "",
        target: "",
        "class": "",
        attributes: ""
    }
};
function isButton(element) {
    return element.type === "button";
}
export const ButtonContentElement = (props) => {
    var _a, _b, _c;
    const [ref, setRef] = useState(null);
    const { containerProps, isActive } = useFocus(props.contentElement.id);
    const [smallViewport] = useMediaQuery('(max-width: 1090px)');
    const { isEditing } = useContentManagement();
    useEffect(() => {
        if (!isButton(props.contentElement) || props.contentElement.data == null) {
            const element = Object.assign(Object.assign({}, props.contentElement), { type: "button", data: defaults });
            props.onChange(element);
        }
    }, [props.contentElement]);
    if (!isButton(props.contentElement) || props.contentElement.data == null) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(Flex, Object.assign({ ref: setRef }, containerProps),
        ref && isActive &&
            React.createElement(ContentControls, { onUp: props.onUp, onDown: props.onDown, onDelete: props.onDelete, label: "Button", attachTo: ref },
                React.createElement(PimcoreLink, { link: props.contentElement.data.link, onChange: (link) => {
                        props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { link }) }));
                    } }),
                React.createElement(FormControl, null,
                    React.createElement(FormLabel, null, "Variant"),
                    React.createElement(SelectControl, { options: [
                            {
                                value: "solid",
                                label: "Solid"
                            },
                            {
                                value: "outline",
                                label: "Outline"
                            },
                            {
                                value: "ghost",
                                label: "Ghost"
                            }
                        ], value: props.contentElement.data.variant, onChange: (variant) => props.onChange(Object.assign(Object.assign({}, props.contentElement), { data: Object.assign(Object.assign({}, props.contentElement.data), { variant: variant.value }) })) }))),
        (!props.contentElement.data.link.text || !props.contentElement.data.link.path) &&
            React.createElement(Text, null, "Add a label and path to use button"),
        ((_a = props.contentElement.data.link.text) !== null && _a !== void 0 ? _a : false) && ((_b = props.contentElement.data.link.path) !== null && _b !== void 0 ? _b : false) &&
            (React.createElement(PimcoreLinkButton, { link: props.contentElement.data.link, pointerEvents: isEditing ? "none" : undefined, colorScheme: "brand", size: "md", variant: props.contentElement.data.variant }, (_c = props.contentElement.data.link.text) !== null && _c !== void 0 ? _c : ""))));
};
